export default __webpack_public_path__ + "static/media/Female.eb02da36.png";